/*
  DCC free car decal selector (added 28 Sep 2026).
  Handles "Add free" clicks on the decal cards rendered by snippets/dcc-decal-offer.liquid
  in the cart drawer and on the cart page. Adds the chosen decal variant, then tells the
  theme the cart changed (same cart:update event Horizon's own cart code uses) so the
  drawer/page re-render with the new line and the updated card.
  The $0 price is applied by the automatic "Free car decal with your dash cam" discount.
*/
(function () {
  if (window.__dccDecalOffer) return;
  window.__dccDecalOffer = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setBusy(wrap, busy) {
    if (!wrap) return;
    wrap.querySelectorAll('[data-dcc-decal-add]').forEach(function (b) {
      b.disabled = busy;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-dcc-decal-add]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var id = Number(btn.getAttribute('data-dcc-decal-add'));
    var wrap = btn.closest('[data-dcc-decal]');
    var err = wrap ? wrap.querySelector('[data-dcc-decal-error]') : null;
    var cta = btn.querySelector('.dcc-decal__cta');
    if (err) err.hidden = true;
    setBusy(wrap, true);
    if (cta) cta.textContent = 'Adding…';

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      var sid = el.dataset && el.dataset.sectionId;
      if (sid && sectionIds.indexOf(sid) === -1) sectionIds.push(sid);
    });

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'add failed');
          return data;
        });
      })
      .then(function (data) {
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: 'dcc-decal-offer',
                  data: {
                    source: 'dcc-decal-offer',
                    itemCount: cart.item_count,
                    variantId: String(id),
                    sections: data.sections || undefined
                  }
                }
              })
            );
          });
      })
      .catch(function () {
        if (err) {
          err.textContent = 'Sorry, we couldn’t add that decal. Please try again.';
          err.hidden = false;
        }
        setBusy(wrap, false);
        if (cta) cta.textContent = 'Add free';
      });
  });
})();
